import * as React from 'react';
import { Saturation as SaturationBase } from 'react-color/lib/components/common';
import styled from 'styled-components';
import tinycolor from 'tinycolor2';

import { getColor } from '@process-advisor/process-miner/shared/theme';

const Container = styled.div`
    width: 100%;
    padding-bottom: 147px;
    border-radius: 3px;
    position: relative;
    overflow: hidden;
`;

const CustomPointer = styled.div`
    cursor: pointer;
    width: 14px;
    border-radius: 50%;
    height: 14px;
    transform: translate(-7px, -5px);
    border: 2px solid ${getColor('white')};
`;

type Props = {
    activeColor: string;
    onColorChange: (color: string) => void;
};

export const Saturation: React.FC<Props> = ({ activeColor, onColorChange }) => (
    <Container>
        <SaturationBase
            onChange={({ h, s, v, a }) => {
                const color = a === 1
                    ? tinycolor({ h, s, v }).toHexString()
                    : tinycolor({ h, s, v, a }).toHex8String();
                onColorChange(color);
            }}
            hsl={tinycolor(activeColor).toHsl()}
            hsv={tinycolor(activeColor).toHsv()}
            pointer={CustomPointer} />
    </Container>
);
